module.exports = __webpack_public_path__ + "images/vkb_schnellrechner_scenario_2_web.svg?24aa2185629793cf21e62acb88e4e278";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_schnellrechner_scenario_2_web.svg
// module id = MQzU
// module chunks = 0